import { render, staticRenderFns } from "./BirthsHome.vue?vue&type=template&id=2dbdfcb4&scoped=true"
import script from "./BirthsHome.vue?vue&type=script&lang=js"
export * from "./BirthsHome.vue?vue&type=script&lang=js"
import style0 from "./BirthsHome.vue?vue&type=style&index=0&id=2dbdfcb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbdfcb4",
  null
  
)

export default component.exports